import { __decorate } from "tslib";
import { Options, Vue } from "vue-class-component";
import "tippy.js/dist/backdrop.css";
import "tippy.js/animations/shift-away.css";
import "tippy.js/themes/translucent.css";
let Test = class Test extends Vue {
    msg;
};
Test = __decorate([
    Options({
        props: {
            msg: String,
        },
        components: {},
        data() {
            return {
                props: {
                    // content: 'Hi!',
                    trigger: "mouseenter focus",
                    animation: "fade",
                    placement: "top",
                    theme: "translucent",
                    touch: true,
                    arrow: true,
                    duration: [300, 250],
                    delay: [100, null],
                    interactiveBorder: 2,
                    interactiveDebounce: 0,
                    maxWidth: 350,
                    offset: [0, 10],
                    // sticky: true,
                    // zIndex: 9999,
                    // followCursor: true,
                    // interactive: true,
                    // hideOnClick: 'toggle',
                    // onShow(instance, partialProps) {},
                },
            };
        },
        computed: {},
        methods: {},
        mounted() { },
    })
], Test);
export default Test;
